import { Alert as MuiAlert, styled } from '@mui/material';

const Alert = styled(MuiAlert)`
  flex-grow: 1;
  cursor: pointer;

  & .MuiAlert-icon {
    align-items: center;
  }
`;

export default Alert;
